import { useState, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { authApi, ticketsApi } from '../services/api';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const queryClient = useQueryClient();

  const register = async (data) => {
    try {
      const response = await authApi.register(data);
      setUser(response.data.user);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const login = async (data) => {
    try {
      const response = await authApi.login(data);
      localStorage.setItem('token', response.data.token);
      // Получаем полный профиль пользователя
      const me = await authApi.me();
      setUser(me.data);
      localStorage.setItem('user', JSON.stringify(me.data));
      // Prefetch tickets to minimize delay
      await queryClient.prefetchQuery({ queryKey: ['tickets'], queryFn: ticketsApi.getAll });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    queryClient.clear();
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const me = await authApi.me();
        setUser(me.data);
        localStorage.setItem('user', JSON.stringify(me.data));
      } catch {
        // fallback на localStorage если сервер недоступен
        const storedUser = localStorage.getItem('user');
        if (storedUser) setUser(JSON.parse(storedUser));
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  return {
    user,
    register,
    login,
    logout,
    loading,
  };

};
